import { FC, useCallback } from 'react';
import Location from 'icon/location.svg';
import Phone from 'icon/phone.svg';
import { useAtomValue } from 'jotai';
import { $CurrentPOIInfoAsAvailable } from '@poi/shared/current-poi-info';
import cls from 'classnames';
import { useTranslation } from 'react-i18next';
import { useCTADirectly } from '~/utils/cta';
import { EClickPosition } from 'shared/constant';
import { ELEMENT_TIMING_FMP } from '@lemon8/web-app-shared/component';

import './style.scss';

export const POIInfo: FC = () => {
  const { t } = useTranslation();
  const poi = useAtomValue($CurrentPOIInfoAsAvailable);

  const hasType = poi.type !== 'others' && Boolean(poi.typeName);

  const address = poi.formattedAddressWithoutPostCountryAsc || poi.formattedAddress;
  const phone = poi.internationalPhoneNumber;

  const handleNavigation = useCTADirectly({
    clickPosition: EClickPosition.RelatedAddress,
    onClick: useCallback(() => {
      const target = new URL('https://www.google.com/maps/search/?api=1');
      target.searchParams.set('query', address || '');
      target.searchParams.set('query_place_id', poi.placeId || '');

      window.open(target.toString(), '_blank');
    }, [poi]),
  });

  const handlePhoneCall = useCTADirectly({
    clickPosition: EClickPosition.RelatedPhone,
    onClick: useCallback(() => {
      location.href = `tel:${phone}`;
    }, []),
  });

  return (
    <>
      <div className="message-bar">
        <div
          className={cls('poi-name', {
            'name-margin': !hasType,
          })}
          elementtiming={ELEMENT_TIMING_FMP}
        >
          {poi.name}
        </div>
        {hasType && <span>{poi.typeName}</span>}
        {(Boolean(address) || Boolean(phone)) && (
          <div className="active-bar">
            <div className="address">{address || t('poi_no_address_information')}</div>
            {Boolean(address) && <Location className="img-navigation" onClick={handleNavigation} />}
            {Boolean(address) && Boolean(phone) && <div className="line" />}
            {Boolean(phone) && <Phone className="img-phone" onClick={handlePhoneCall} />}
          </div>
        )}
      </div>
    </>
  );
};
